export default {
  getTooltipById: state => id => state.tooltips?.filter(item => item.id === id)[0] || null,
  getTooltipBySlug: state => slug => state.tooltips?.filter(item => item.attributes.Slug === slug)[0] || null,
  getTooltipTextById: (state, getters) => id => getters.getTooltipById(id)?.attributes.Text || '',
  getTooltipTextBySlug: (state, getters) => slug => getters.getTooltipBySlug(slug)?.attributes.Text || '',
  getProductImageById: (state, getters) => id => getters.getTooltipById(id)?.attributes.Image.attributes.data.url || null,
  getProductImageBySlug: (state, getters) => slug => getters.getTooltipBySlug(slug)?.attributes?.Image?.data?.attributes?.url || null
}
